import React, { useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import PasswordField from '../../../Base/Components/Inputs/PasswordField/PasswordField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import Loading from '../../../../Components/Loading';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

interface ElectronicSignaturePasswordRequestValues {
	certificatePassword: string;
}

interface Props {
	onVerify: () => void;
	submitButtonText?: string;
}

const validationSchema = yup.object({
	certificatePassword: yup
		.string()
		.required(
			'validation.electronicSignaturePasswordRequest.certificatePassword',
		),
});

const ElectronicSignaturePasswordRequest: React.FC<Props> = ({
	onVerify,
	submitButtonText,
}) => {
	const { displayError } = useApiClient();
	const [isLoading, setIsLoading] = useState(false);
	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (vals: any) => {
		setIsLoading(true);
		const values: ElectronicSignaturePasswordRequestValues = vals;

		try {
			const response = await apiClient.post('/certificate/test', {
				password: values.certificatePassword,
			});
			if (response.status === 200) {
				onVerify();
			}
		} catch (e) {
			displayError(e);
		}

		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<FormWrapper formMethods={formMethods}>
			<PasswordField
				name='certificatePassword'
				label='component.electronicSignaturePasswordRequest.password'
				isRequired
			/>
			<div className='mt-3'>
				<SubmitButton onSubmit={handleSubmit} title={submitButtonText} />
			</div>
		</FormWrapper>
	);
};

export default ElectronicSignaturePasswordRequest;
